import styled from 'styled-components';
import { Link } from '../../common/components/Link';
import { ThemeColours } from '../../common/styles/ThemeColours';
import { FontWeight, FONT_STACK, PRESSABLE } from '../../common/styles/constants';
import Image from './Error.color.svg';

export const ErrorView = styled.div`
  ${FONT_STACK};
  align-items: center;
  background: ${ThemeColours.white};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px;
  text-align: center;
  width: 100%;
`;

export const StyledImage = styled(Image)`
  margin: 32px 80px 40px;
  max-width: 296px;
  width: 100%;
`;

export const Header = styled.div`
  color: ${ThemeColours.mono700};
  font-size: 32px;
  font-weight: ${FontWeight.BOLD};
  line-height: 1.31em;
  margin-bottom: 8px;
`;

export const Subheader = styled.div`
  color: ${ThemeColours.mono700};
  font-size: 22px;
  line-height: 1.31em;
  margin-bottom: 16px;
  padding: 0 24px;
`;

export const Message = styled.div`
  color: ${ThemeColours.mono700};
  font-size: 14px;
  line-height: 1.64em;
  margin-bottom: 48px;
  max-width: 472px;
`;

export const Links = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 64px;
`;

export const StyledLink = styled(Link)`
  ${PRESSABLE};
  color: ${ThemeColours.primary};
  font-size: 16px;
  font-weight: ${FontWeight.SEMI_BOLD};
  margin-bottom: 12px;
  text-decoration: none;
`;
